import { render, staticRenderFns } from "./SyllabusEducatorsAdminActions.vue?vue&type=template&id=6243a1c3&scoped=true&"
import script from "./SyllabusEducatorsAdminActions.vue?vue&type=script&lang=js&"
export * from "./SyllabusEducatorsAdminActions.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusEducatorsAdminActions.vue?vue&type=style&index=0&id=6243a1c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6243a1c3",
  null
  
)

export default component.exports